import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from "react-router-dom";
import Strings from  '../common/Strings';
import { StateArray } from '../common/Constants';
import { selectOptions } from '../common/Forms';

import { getAccountsApiUrl, apiGet, apiPost } from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import MessageTag2 from '../common/MessageTag';
import { decodeValues, formatPhone } from '../common/Formats'
import { translate, loadApplyLanguage, saveApplyLanguage, DEFAULT_LANGUAGE } from './ApplyTranslations';
import ApplyLanguageSelect from './ApplyLanguageSelect';

export default function CTApplication() {
    let blankApplicant = {
        firstname:'',
        lastname:'',
        middlename:'',
        address1:'',
        address2:'',
        city:'',
        stateId:'',
        zipcode:'',
        email:'',
        mobilePhone:''
    };
    
    let [applicant, setApplicant] = useState(blankApplicant);
    let [screen, setScreen] = useState(-1);
    let [applicantion, setApplication] = useState({name:'',descr:''});
    let [program, setProgram] = useState({programId:null, programUuid:'', programName:'', shortName:''});

    let [showSpinner, setSpinner] = useState(false);
    let [message, setMessage] = useState();
    let [message2, setMessage2] = useState();
    let [agreementHtml, setAgreementHtml] = useState('');
    let history = useHistory();
    let location = useLocation();
    let params = useParams();
    // Links from other sites can name a language: /apply/es or /apply?lang=es
    let [language, setLanguageState] = useState(() => loadApplyLanguage(params.lang, location.search));

    let t = (key) => translate(key, language);

    let setLanguage = (code) => {
        setLanguageState(code);
        saveApplyLanguage(code);

        // If the link named a language, point it at the new one so a refresh keeps the choice.
        if (params.lang) {
            history.replace({pathname: '/apply/' + code, search: location.search});
        } else {
            let query = new URLSearchParams(location.search);
            if (query.get('lang')) {
                query.set('lang', code);
                history.replace({pathname: location.pathname, search: '?' + query.toString()});
            }
        }
    };

    useEffect( () => {
        document.documentElement.lang = language;
    }, [language]);

    // put the page language back for the rest of the site
    useEffect( () => () => { document.documentElement.lang = DEFAULT_LANGUAGE; }, []);

    // Messages are held as translation keys so they follow a language change.
    let showMessage = (msg) => msg ? {text: t(msg.key), type: msg.type} : msg;

    let patternValidity = (key) => (e) => {
        e.target.setCustomValidity(e.target.validity.patternMismatch ? t(key) : '');
    };

	let handleFieldChange = (event) => {
		const {id, value} = event.target;
		let cloned = {...applicant, [id]:value};
		setApplicant(cloned);
	}

    let stopSpinner = () => {
        setSpinner(false);
    };

    let handleNextScreen = (e) => {
        e.preventDefault();
        setScreen(screen + 1);
    };
    let previousScreen = () => {
        setScreen(screen - 1);
    };

    let getApplInfo = () => {
        let success = (resp) => {
            //console.debug(resp);

            if (resp) {
                setApplication(resp);
                if (resp && resp.active == true && resp.programs && resp.programs.length) {
                    setProgram(resp.programs[0])
                    setScreen(1);
                } else {
                    setMessage({key:'apply.unavailable', type:'warning'});
                }
            } else {
                setMessage({key:'apply.unavailable', type:'warning'});
            }

        };
        let fail = (resp) => {
            console.error(resp);
            setMessage({key:'apply.unavailable', type:'warning'});
        };

        setSpinner(true);

        apiGet(getAccountsApiUrl() + '/application/1')
        .then(success)
        .catch(fail)
        .finally(stopSpinner);
    }

    let handleSubmit = (e) => {
        e.preventDefault();
        console.debug('submit to backend');

        setSpinner(true);

        let body = {...applicant, programId:program.programId};

        apiPost(getAccountsApiUrl() + '/applicant', body).then( (resp) => {
            //console.debug(resp);
            setScreen(screen + 1);
        }).catch( (error) => {
            console.debug(error);
            setMessage2({key:'apply.submitFailed', type:'danger'});
        })
        .finally(stopSpinner);
    };

    useEffect( () => {

        getApplInfo();

        fetch('/terms-of-use.html')
        .then( (resp) => resp.text() )
        .then(setAgreementHtml)
        .catch( (error) => console.error(error) );
    }, []);

    let doAgreementMarkup = () => {
        return {__html: agreementHtml};
    };

    let btnMargin = {marginRight:'.2em'};
    // Keep the single-character input narrow even though its column is wide enough for long translated labels.
    let initialInputWidth = {width:'4em'};

    let languageSelect = <ApplyLanguageSelect language={language} onChange={setLanguage} />;

    // Only the "Select One" placeholder is translated; state names stay as-is.
    let stateOptions = [{...StateArray[0], text:t('apply.selectOne')}, ...StateArray.slice(1)];

    let doMarkup = () => {
        return {__html: applicantion.descr};
    };

    if (screen == 1) {
        return (
            <div className="container">
                {languageSelect}
                <h3>{applicantion.name}</h3>
                <p dangerouslySetInnerHTML={doMarkup()}></p>

                <form onSubmit={handleNextScreen}>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="firstname">{t('apply.firstName')}</label>
                            <input type="text" id="firstname" className="form-control" onChange={handleFieldChange} value={applicant.firstname} required maxLength="100" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-12 col-sm-6">
                            <label htmlFor="middlename">{t('apply.middleInitial')}</label>
                            <input type="text" id="middlename" className="form-control" style={initialInputWidth} onChange={handleFieldChange} value={applicant.middlename} maxLength="1" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="lastname">{t('apply.lastName')}</label>
                            <input type="text" id="lastname" className="form-control" onChange={handleFieldChange} value={applicant.lastname} required maxLength="100" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="address1">{t('apply.address1')}</label>
                            <input type="text" id="address1" className="form-control" onChange={handleFieldChange} value={applicant.address1} required maxLength="60" />
                        </div>
                        <div className="form-group col-12 col-sm-6">
                            <label htmlFor="address2">{t('apply.address2')}</label>
                            <input type="text" id="address2" className="form-control" onChange={handleFieldChange} value={applicant.address2} maxLength="60"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="city">{t('apply.city')}</label>
                            <input type="text" id="city" className="form-control" onChange={handleFieldChange} value={applicant.city} required maxLength="60" />
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="stateId">{t('apply.state')}</label>
                            <select id="stateId" className="form-control custom-select" value={applicant.stateId} onChange={handleFieldChange} required >
                                { selectOptions(stateOptions, 'id2') }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="zipcode">{t('apply.zipcode')}</label>
                            <input type="text" id="zipcode" className="form-control" onChange={handleFieldChange} value={applicant.zipcode} required maxLength="10" pattern="(\d{5}([\-]\d{4})?)" onInput={patternValidity('apply.zipFormat')} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="email">{t('apply.email')}</label>
                            <input type="email" id="email" className="form-control" onChange={handleFieldChange} value={applicant.email} required maxLength="255" pattern={Strings.pattern.email} onInput={patternValidity('apply.emailFormat')} />
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="mobilePhone">{t('apply.mobilePhone')}</label>
                            <input type="text" id="mobilePhone" className="form-control" onChange={handleFieldChange} value={applicant.mobilePhone} required maxLength="20" pattern={Strings.pattern.phone} onInput={patternValidity('apply.phoneFormat')} />
                        </div>
                    </div>
                    <button className="btn btn-primary" id="btnReview" disabled={program.programId==null}>{t('apply.reviewApplication')}</button>
                </form>
            </div>
        );
    } else if (screen == 2) {
        return <div className='container'>
                {languageSelect}
                <h3>{applicantion.name}</h3>
                <h4>{t('apply.applicantInformation')}</h4>
                <p>{t('apply.reviewIntro')}</p>
                <table className='table table-bordered'>
                <tbody>
                    <tr>
                        <th>{t('apply.firstName')}</th>
                        <td>{applicant.firstname}</td>
                        <th>{t('apply.middleName')}</th>
                        <td>{applicant.middlename}</td>
                        <th>{t('apply.lastName')}</th>
                        <td>{applicant.lastname}</td>
                    </tr>
                    <tr>
                        <th>{t('apply.address1')}</th>
                        <td colSpan={5}>{applicant.address1}</td>
                    </tr>
                    <tr>
                        <th>{t('apply.address2')}</th>
                        <td colSpan={5}>{applicant.address2}</td>
                    </tr>
                    <tr>
                        <th>{t('apply.city')}</th>
                        <td>{applicant.city}</td>
                        <th>{t('apply.state')}</th>
                        <td>{decodeValues(applicant.stateId, StateArray, 'id2')}</td>
                        <th>{t('apply.zipcode')}</th>
                        <td>{applicant.zipcode}</td>
                    </tr>
                    <tr>
                        <th>{t('apply.email')}</th>
                        <td colSpan={2}>{applicant.email}</td>
                        <th>{t('apply.mobilePhone')}</th>
                        <td>{formatPhone(applicant.mobilePhone)}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={previousScreen} id="btnEdit">{t('apply.editApplication')}</button>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={handleNextScreen} id="btnContinue">{t('apply.continueApplication')}</button>
        </div>
    } else if (screen == 3) {
        let checkboxMessage = (e) => {
            let myMsg = '';
            if (e.target.validity.valueMissing)
                myMsg = t('apply.mustAgree');
            e.target.setCustomValidity(myMsg);
        };
        let checkBoxStyle = {accentColor: '#56CC9D', transform:'scale(1.4)'};
        return <div className='container'>
            {languageSelect}
            <h3>{applicantion.name}</h3>
            <br/>
            <Processing show={showSpinner}/>
            {language !== 'en' && <div className="alert alert-info" id="termsEnglishOnly">{t('apply.termsEnglishOnly')}</div>}
            <div dangerouslySetInnerHTML={doAgreementMarkup()} lang="en"></div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group col-12">
                        <div className="form-check">
                            <label className='form-check-label' htmlFor="iAgree" style={{padding:'.1em'}}>
                            <input className="form-check-input" type="checkbox" value="true" id="iAgree" style={checkBoxStyle} required onInvalid={checkboxMessage} onChange={checkboxMessage} />
                            &nbsp;{t('apply.agreePrefix')}<strong>{t('apply.termsOfUse')}</strong>{t('apply.agreeSuffix')}
                            </label>
                        </div>
                    </div>
                <button className='btn btn-success' id='btnSubmit'>{t('apply.submitApplication')}</button>
                <span style={{display:'inline-block', margin:'.7em'}}>
                <MessageTag2 message={showMessage(message2)}/>
                </span>
                <br/>

                <button className="btn btn-primary" type='button' onClick={previousScreen} id="btnBack">{t('apply.backToReview')}</button>
            </form>
        </div>
    } else if (screen == 4) {
        return <div className='container'>
            {languageSelect}
            <h3>{applicantion.name}</h3>
            <h4 id="thankYou">{t('apply.thankYou')}</h4>
            <p>{t('apply.received')}</p>
            <a href="">{t('apply.addAnother')}</a>
        </div>
    } else {
        return <div className='container'>
            {languageSelect}
            <h3>{applicantion.name}</h3>
            <MessageTag message={showMessage(message)}/>
            <Processing show={showSpinner}/>
            <p>{t('apply.sorry')}</p>
        </div>
    }
}
